import { Component, OnInit, Input } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { GSFReport } from "../GSF-report.service";
import { activityInput } from "../models/index";
import { InputModel } from "../models";
import { InputValidationService } from "../service/input-validation.service";

@Component({
  selector: "app-dropdown-multiple",
  templateUrl: "./dropdown-multiple.component.html",
  styleUrls: ["./dropdown-multiple.component.css"],
})
export class DropdownMultipleComponent implements OnInit {
  @Input() activity: activityInput;
  @Input() activityControl: UntypedFormControl;
  @Input() activityInputList: InputModel[];
  selectedlang: string;

  constructor(
    private readonly translate: TranslateService,
    public report: GSFReport,
    private readonly inputValService: InputValidationService
  ) {
    this.translate.setDefaultLang("eng");
    this.selectedlang = "eng";
  }

  ngOnInit() {
    this.activityControl.valueChanges.subscribe((value) => {
      this.activity.ans = value;
    });
    this.enableDisableDependControls();
    if(!(this.activity.ans && this.activity.ans.length > 0)){
      if(this.activity.defaultDisable === true) {
        this.activityControl.disable();
      }
    }
  }
  getTooltipText(data) {
    let toolTipText = " ";
    if (data && data.length && this.activity.values != null) {
      const multiSelectValues: any = this.activity.values;
      const dataPresent = multiSelectValues.filter((x) => {
        if (data.includes(x.value)) {
          return true;
        } else {
          return false;
        }
      });
      if (dataPresent != null && dataPresent.length > 0) {
        toolTipText = dataPresent.map((o) => o.name).join(" ,");
        return toolTipText;
      } else {
        return toolTipText;
      }
    } else {
      return toolTipText;
    }
  }

  populateDependvalues(ans: any) {
    if (ans && ans.length > 0) {
      this.enableDisableDependControls();
    }
  }
  private enableDisableDependControls() {
    if (this.activity["dependancy"].flag) {
      const deptId = this.activity["dependancy"]["depId"];
      this.populateDropDown(deptId);
    }
  }
  populateDropDown(deptId) {
    this.activityInputList.forEach((obj) => {
      if (obj.inputControlID === deptId) {
        if (this.validateSelectedDependancy(obj)) {
          this.enableDependedInputs(deptId);
        } else {
          this.disableDependedInputs(deptId);
        }
      }
    });
  }
  validateSelectedDependancy(obj) {
    if (this.activity.ans) {
      return (this.activity.ans as any).some((an) => {
        return obj[an];
      });
    } else {
      return false;
    }
  }
  enableDependedInputs(deptId) {
    const inpCtl = this.inputValService.inputFormCtlAndObj[deptId]
      .inputControl as UntypedFormControl;
    inpCtl.enable();
  }

  disableDependedInputs(deptId) {
    const inpCtl = this.inputValService.inputFormCtlAndObj[deptId]
      .inputControl as UntypedFormControl;
    inpCtl.setValue(null);
    inpCtl.disable();
  }
}
